import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VehicleDataService {
  public selectedVehicle: any;
  tripReportFormState: any = null;

  constructor() { }

  setTripReportFormState(formState) {
    this.tripReportFormState = formState;
  }

  setSelectedVehicle(mapData) {
    this.selectedVehicle = mapData
  }

  getSelectedVehicle() {
    return this.selectedVehicle;
  }
}
